import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
import { DomSanitizer, SafeResourceUrl   } from "@angular/platform-browser";
import { ModalComponent } from "../../../modal/modal.component";
import { InicioService } from '../../../../services/inicio.service';
import { PlanificacionCumplimientoService } from '../../../../services/planificacion-cumplimiento.service';
import { appsettings } from '../../../../settings/appsettings';

@Component({
  selector: 'app-documentos',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule],
  templateUrl: './documentos.component.html',
  styleUrl: './documentos.component.css'
})
export class DocumentosComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() id_estudiante?: any;
  @Input() nombre_participante?: any;
  @Output() vuelve = new EventEmitter<any>();

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  errorMessage: string = '';

  documentos: any = [];

  valNotas: SafeResourceUrl | null = null;
  valConstancia: SafeResourceUrl | null = null;
  valFotografia: SafeResourceUrl | null = null;
  valCarnet: SafeResourceUrl | null = null;
  valCedula: SafeResourceUrl | null = null;
  valRepresentante: SafeResourceUrl | null = null;
  valSalud: SafeResourceUrl | null = null;
  valRif: SafeResourceUrl | null = null;
  valCurriculum: SafeResourceUrl | null = null;
  valReferencia: SafeResourceUrl | null = null;
  valLopna: SafeResourceUrl | null = null;

  private srvLogin = inject(InicioService);
  private servicios = inject(PlanificacionCumplimientoService);
  private sanitizer = inject(DomSanitizer);
  private url = appsettings.apiUrl;

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.documento(this.id_estudiante).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.documentos = rs.data[0].documento;
        if(this.documentos == 0){
          this.vuelve.emit({value: false, validador: true});
        }

        let arr: any[] =[];
        (rs.data[0].documento).forEach((e:any) => {arr.push((e.todo).split("|")[0]) });
        this.valNotas = arr.indexOf('1') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('1')].todo).split("|")[1]}`);
        this.valConstancia = arr.indexOf('2') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('2')].todo).split("|")[1]}`);
        this.valFotografia = arr.indexOf('3') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('3')].todo).split("|")[1]}`);
        this.valCarnet = arr.indexOf('4') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('4')].todo).split("|")[1]}`);
        this.valCedula = arr.indexOf('5') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('5')].todo).split("|")[1]}`);
        this.valRepresentante = arr.indexOf('6') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('6')].todo).split("|")[1]}`);
        this.valSalud = arr.indexOf('7') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('7')].todo).split("|")[1]}`);
        this.valRif = arr.indexOf('8') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('8')].todo).split("|")[1]}`);
        this.valCurriculum = arr.indexOf('9') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('9')].todo).split("|")[1]}`);
        this.valReferencia = arr.indexOf('10') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('10')].todo).split("|")[1]}`);
        this.valLopna = arr.indexOf('11') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('11')].todo).split("|")[1]}`);

        console.log('datos recojidos:  ',this.documentos)
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  // Este método 'transform' ya lo tenías y es correcto,
  // pero asegúrate de llamarlo explícitamente en los lugares donde asignas las URLs.
  transform(url: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  volver(){
    this.vuelve.emit({value: false, validador: false});
  }
}
